import * as React from "react"

import Theme from 'components/basics/theme/Theme'
import Link from 'components/common/link/Link'
import { ReactComponent as Twitter } from 'resources/icons/logos/x_solid.svg'
import { ReactComponent as LinkedIn } from 'resources/icons/logos/linked_simlpe_solid.svg'

import * as st from './Footer.styled.js'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Theme value="dark">
      <st.Wrap>
        <st.Content>
          <st.LogoLink to="/">
            <img
              src="//cdn-platform.scope-dev.ws/website/images/logos/scope-on-dark-28.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/logos/scope-on-dark-28.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/scope-on-dark-28@2x.png 2x"
              width={114}
              height={28}
              alt="Scope"
            />
          </st.LogoLink>
          <st.MenusWrap>
            <st.ProductMenu>
              <st.Menu>
                <st.MenuHeader>Product</st.MenuHeader>
                <Link
                  view="tertiary"
                  size={300}
                  href="/changelog"
                >
                  Changelog
                </Link>
                {/* <Link */}
                {/*   view="tertiary" */}
                {/*   size={300} */}
                {/*   href="/pricing" */}
                {/* > */}
                {/*   Customer Onboarding */}
                {/* </Link> */}
              </st.Menu>
              {/* <st.Menu noHeader> */}
              {/*   <Link */}
              {/*     view="tertiary" */}
              {/*     size={300} */}
              {/*     href="/legal/terms-and-conditions" */}
              {/*   > */}
              {/*     Customer Facing Portal */}
              {/*   </Link> */}
              {/*   <Link */}
              {/*     view="tertiary" */}
              {/*     size={300} */}
              {/*     href="/legal/privacy" */}
              {/*   > */}
              {/*     Sales Deal Room */}
              {/*   </Link> */}
              {/*   <Link */}
              {/*     view="tertiary" */}
              {/*     size={300} */}
              {/*     href="/legal/cookies" */}
              {/*   > */}
              {/*     Integrations */}
              {/*   </Link> */}
              {/* </st.Menu> */}
            </st.ProductMenu>

            {/* <st.Menu> */}
            {/*   <st.MenuHeader>Scope for</st.MenuHeader> */}
            {/*   <Link */}
            {/*     type="a" */}
            {/*     view="tertiary" */}
            {/*     size={300} */}
            {/*     href="https://scope.scope.page/d/v3vyzLs-" */}
            {/*     target="_blank" */}
            {/*   > */}
            {/*     Vertical SaaS */}
            {/*   </Link> */}
            {/*   <Link */}
            {/*     view="tertiary" */}
            {/*     size={300} */}
            {/*     href="/pricing" */}
            {/*   > */}
            {/*     Enterprise SaaS */}
            {/*   </Link> */}
            {/*   <Link */}
            {/*     view="tertiary" */}
            {/*     size={300} */}
            {/*     href="/pricing" */}
            {/*   > */}
            {/*     AI Startups */}
            {/*   </Link> */}
            {/*   <Link */}
            {/*     view="tertiary" */}
            {/*     size={300} */}
            {/*     href="/pricing" */}
            {/*   > */}
            {/*     Logistics, Supply Chain */}
            {/*   </Link> */}
            {/* </st.Menu> */}

            {/* <st.Menu> */}
            {/*   <st.MenuHeader>Resources</st.MenuHeader> */}
            {/*   <Link */}
            {/*     type="a" */}
            {/*     view="tertiary" */}
            {/*     size={300} */}
            {/*     href="https://scope.scope.page/d/v3vyzLs-" */}
            {/*     target="_blank" */}
            {/*   > */}
            {/*     Blog */}
            {/*   </Link> */}
            {/*   <Link */}
            {/*     view="tertiary" */}
            {/*     size={300} */}
            {/*     href="/pricing" */}
            {/*   > */}
            {/*     Help Center */}
            {/*   </Link> */}
            {/*   <Link */}
            {/*     view="tertiary" */}
            {/*     size={300} */}
            {/*     href="/pricing" */}
            {/*   > */}
            {/*     Developers */}
            {/*   </Link> */}
            {/* </st.Menu> */}
          </st.MenusWrap>

          <st.Footer>
            <st.CopyrightWrap>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/logos/scope-gray-16.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/logos/scope-gray-16.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/scope-gray-16@2x.png 2x"
                width={65}
                height={16}
                alt="Scope"
              />
              <st.CopyrightMenuWrap>
                <st.Copyright>
                  © {currentYear} Scope Innovations Inc. All rights reserved.
                </st.Copyright>
                <st.CopyrightDivider />
                <st.FooterMenu>
                  <Link
                    view="tertiary"
                    size={300}
                    href="/legal/terms-and-conditions"
                  >
                    Terms & Conditions
                  </Link>
                  <st.FooterMenuDivider />
                  <Link
                    view="tertiary"
                    size={300}
                    href="/legal/privacy"
                  >
                    Privacy Policy
                  </Link>
                  <st.FooterMenuDivider />
                  <Link
                    view="tertiary"
                    size={300}
                    href="/legal/cookies"
                  >
                    Cookie Policy
                  </Link>
                  <st.FooterMenuDivider />
                  <Link
                    view="tertiary"
                    size={300}
                    href="/security"
                  >
                    Security
                  </Link>
                </st.FooterMenu>
              </st.CopyrightMenuWrap>
            </st.CopyrightWrap>
            <st.SocialWrap>
              <st.SocialLink
                href="https://www.linkedin.com/company/scopehq"
                target="_blank"
              >
                <LinkedIn />
              </st.SocialLink>
              <st.SocialLink
                href="https://twitter.com/scope_hq"
                target="_blank"
              >
                <Twitter />
              </st.SocialLink>
            </st.SocialWrap>
          </st.Footer>
        </st.Content>
      </st.Wrap>
    </Theme>
  )
}

export default Footer
